import { OnClick } from "../../../../../library-js/dom-tools/EventListeners";
import { MultiString } from "../../../../../library-js/i18n/MultiString";
import { AppCommand } from "../../../../../library-js/web-app/commands/AppCommand";
import { ContextMenu } from "../../../../../library-templates/context--menu/ContextMenu";
import { AppLocales } from "../../../i8/AppLocales";
import { RokojoriWebAppToolbar } from "../../rokojori/RokojoriWebAppToolbar";
import { AudioEditorCommandsManager } from "../commands/AudioEditorCommandsManager";
import { LoadSound } from "../commands/project/LoadSound";

export class ToolbarMenu
{  
  static create( toolbar:RokojoriWebAppToolbar )
  {
    let commandsManager = toolbar.app.commandsManager as AudioEditorCommandsManager;

    toolbar.createEntry( AppLocales.Project, 
      [
        commandsManager.loadSound
      ]
    );

    toolbar.createEntry( AppLocales.Edit, 
      [
        commandsManager.undo,
        commandsManager.redo
      ]
    );
   
    toolbar.createEntry( AppLocales.Audio, 
      [
        commandsManager.play
      ]
    );

    toolbar.createEntry( AppLocales.Export, 
      [
        commandsManager.sliceClips,
        commandsManager.exportAudio
      ]
    );

    toolbar.createEntry( AppLocales.View, 
      [
        commandsManager.setFullscreen
      ]
    );

  }

 
  
}